import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  section: {
    marginBottom: theme.spacing(4),
  },
  sectionTitle: {
    marginBottom: theme.spacing(2),
  },
  editorLabel: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(0.5),
  },
  colorField: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
  },
  colorSwatch: {
    width: 32,
    height: 32,
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.divider}`,
    flexShrink: 0,
  },
  certificatePreviewWrapper: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: theme.shadows[2],
    overflow: 'hidden',
    lineHeight: 0,
  },
  certificatePreview: {
    width: '100%',
    display: 'block',
  },
  dialogHeader: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: theme.spacing(1, 1, 0),
  },
  dialogContent: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(2),
  },
  previewImage: {
    maxWidth: '100%',
    maxHeight: '80vh',
    objectFit: 'contain',
    borderRadius: theme.shape.borderRadius,
  },
  signatureToggle: {
    display: 'flex',
    justifyContent: 'space-between',
    marginLeft: 0,
    marginBottom: theme.spacing(2),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(0.5, 1.5),
  },
}))

export default useStyles
